var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "footer" }, [
    _vm._m(0),
    _c("div", { staticClass: "links" }, [
      _c(
        "a",
        {
          class: [_vm.lang],
          attrs: {
            target: "_blank",
            href: "https://www.strategybrain.ca/privacy-policy/",
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("PrivacyPolicy")) + " ")]
      ),
      _c(
        "a",
        {
          class: [_vm.lang],
          attrs: {
            target: "_blank",
            href: "https://www.strategybrain.ca/news/customer-success/handbook/",
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("HelpCenter")) + " ")]
      ),
      _c(
        "a",
        {
          class: [_vm.lang],
          attrs: {
            target: "_blank",
            href: "https://www.strategybrain.ca/contact-us/",
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("ContactUs")) + " ")]
      ),
      _c(
        "a",
        {
          class: [_vm.lang],
          attrs: {
            target: "_blank",
            href: "https://www.strategybrain.ca/faqs/",
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("FAQ")) + " ")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "copyright" }, [
      _c(
        "a",
        {
          staticStyle: { color: "rgba(0, 0, 0, 0.45)" },
          attrs: { href: "https://www.strategybrain.ca/", target: "_blank" },
        },
        [_vm._v("©Strategybrain Technology Ltd.")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }